<template>
	<div>
		<v-container>
			<v-row>
				<v-col cols="12">
					<v-breadcrumbs :items="breadcrumbs">
						<template #divider>
							<v-icon>mdi-chevron-left</v-icon>
						</template>
					</v-breadcrumbs>
				</v-col>
			</v-row>

			<v-card>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="8" md="9">
							<div>
								<v-icon right size="24">mdi-account</v-icon>
								<span>
									<b>اسم المستخدم:</b>
									{{ profile.displayName }}
								</span>
							</div>
							<div>
								<v-icon right size="24">mdi-card-account-details</v-icon>
								<span>
									<b>الاسم:</b>
									{{ profile.fullName }}
								</span>
							</div>
							<div>
								<v-icon right size="24">mdi-account-multiple</v-icon>
								<span>
									<b>المجموعة:</b>
									{{ profile.userGroup }}
								</span>
							</div>
							<div>
								<v-icon right size="24">mdi-at</v-icon>
								<span>
									<b>البريد الإلكتروني:</b>
									{{ profile.email }}
								</span>
							</div>
							<div>
								<v-icon right size="24">mdi-human-male-female</v-icon>
								<span>
									<b>الجنس:</b>
									{{ profile.gender }}
								</span>
							</div>
							<div>
								<v-icon right size="24">mdi-cellphone-android</v-icon>
								<span>
									<b>رقم الجوال:</b>
									&nbsp;
									<span dir="ltr">
										{{ profile.phoneNumber }}
									</span>
								</span>
							</div>
							<div>
								<v-icon right size="24">mdi-doctor</v-icon>
								<span>
									<b>التخصص:</b>
									&nbsp;
									<span dir="ltr">
										<template v-if="profile.specialties && profile.specialties.name">
											{{ profile.specialties.name }}
										</template>
										<template v-else>
											...
										</template>
									</span>
								</span>
							</div>
							<div v-for="communication in communications" :key="communication.id">
								<template v-if="true">
									<v-icon right size="24">{{ 'mdi-' + communication.communicationTypeID }}</v-icon>
									<span>
										<b>{{ communication.name }}:</b>
										&nbsp;
										<span dir="ltr">
											<a :href="communication.value" target="_blank" rel="noopener noreferrer">
												{{ communication.value }}
											</a>
										</span>
									</span>
								</template>
							</div>
							<div v-if="communicationLoading" class="pt-2">
								جاري جلب بيانات مواقع التواصل الاجتماعي...
							</div>
						</v-col>

						<v-col cols="12" sm="4" md="3">
							<v-img contain class="mx-auto" aspect-ratio="1" max-width="300" :src="profile.avatar">
								<template #placeholder>
									<v-row class="fill-height ma-0" align="center" justify="center">
										<v-progress-circular indeterminate color="primary"></v-progress-circular>
									</v-row>
								</template>
							</v-img>
						</v-col>

						<!-- <v-col cols="12" class="text-center pb-0">
							<v-row dense>
								<v-col cols="12" sm="6" md="3">
									<v-btn disabled block rounded color="primary" @click="showModifyEmailDialog">
										تغيير البريد الإلكتروني
									</v-btn>
								</v-col>
								<v-col cols="12" sm="6" md="3">
									<v-btn disabled block rounded color="primary" @click="showModifyPhoneDialog">تغيير رقم الهاتف</v-btn>
								</v-col>
								<v-col cols="12" sm="6" md="3">
									<v-btn disabled block rounded color="primary" @click="showModifyPasswordDialog">تغيير كلمة المرور</v-btn>
								</v-col>
								<v-col cols="12" sm="6" md="3">
									<v-btn disabled block rounded color="primary" @click="showModifyAvatarDialog">تغيير الصورة الشخصية</v-btn>
								</v-col>
							</v-row>
						</v-col> -->
					</v-row>
				</v-card-text>
			</v-card>

			<br>

			<v-tabs v-model="tab" class="elevation-2" centered="centered" grow="grow">
				<v-tabs-slider></v-tabs-slider>

				<v-tab href="#tab-1">
					الدورات التدريبية
					<v-icon left>mdi-teach</v-icon>
				</v-tab>

				<v-tab href="#tab-2">
					الأخبار العامة
					<v-icon left>mdi-newspaper</v-icon>
				</v-tab>

				<v-tab href="#tab-3">
					النقل ببديل
					<v-icon left>mdi-account-switch</v-icon>
				</v-tab>

				<v-tab href="#tab-4">
					الفعاليات
					<v-icon left>mdi-calendar</v-icon>
				</v-tab>

				<v-tab href="#tab-5">
					الوظائف الطبية
					<v-icon left>mdi-doctor</v-icon>
				</v-tab>

				<v-tab href="#tab-6">
					المكتبة الطبية
					<v-icon left>mdi-library</v-icon>
				</v-tab>

				<v-tab-item value="tab-1">
					<v-card-text>
						<div class="text-subtitle-1 pb-2">
							<strong>التي تم انشاوها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="coursesCreatedHeaders"
							:items="media.coursesCreated == null ? [] : media.coursesCreated"
							show-expand
							:loading="media.coursesCreated == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'course', params: { courseID: item.id }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
							<template #expanded-item="{ item }">
								<td :colspan="coursesCreatedHeaders.length">
									<v-row>
										<v-col>
											<b>تاريخ بداية التسجيل:</b>
											{{ item.registerStart }}
											<v-spacer></v-spacer>
											<b>تاريخ نهاية التسجيل:</b>
											{{ item.registerEnd }}
											<template v-if="item.accrediting.length">
												<v-spacer></v-spacer>
												<template v-if="item.accrediting.length == 1">
													<b>جهة الإعتماد:</b>
													{{ item.accrediting[0] }}
												</template>
												<template v-else>
													<b>جهات الإعتماد:</b>
													<ul>
														<li v-for="accrediting in item.accrediting" :key="accrediting">
															{{ accrediting }}
														</li>
													</ul>
												</template>
												<v-spacer></v-spacer>
												<b>عدد ساعات الإعتماد:</b>
												{{ item.hoursCount }}
											</template>
											<template v-if="item.registrationLink">
												<v-spacer></v-spacer>
												<b>رابط التسجيل:</b>
												&nbsp;
												<a
													:href="item.registrationLink"
													target="_blank"
													rel="noopener noreferrer"
												>{{ item.registrationLink }}</a>
											</template>
										</v-col>
									</v-row>
								</td>
							</template>
						</v-data-table>

						<br>

						<div class="text-subtitle-1 pb-2">
							<strong>التي تم نشرها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="coursesPublishedHeaders"
							:items="media.coursesPublished == null ? [] : media.coursesPublished"
							show-expand
							:loading="media.coursesPublished == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'course', params: { courseID: item.id }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
							<template #expanded-item="{ item }">
								<td :colspan="coursesPublishedHeaders.length">
									<v-row>
										<v-col>
											<b>تاريخ بداية التسجيل:</b>
											{{ item.registerStart }}
											<v-spacer></v-spacer>
											<b>تاريخ نهاية التسجيل:</b>
											{{ item.registerEnd }}
											<template v-if="item.accrediting.length">
												<v-spacer></v-spacer>
												<template v-if="item.accrediting.length == 1">
													<b>جهة الإعتماد:</b>
													{{ item.accrediting[0] }}
												</template>
												<template v-else>
													<b>جهات الإعتماد:</b>
													<ul>
														<li v-for="accrediting in item.accrediting" :key="accrediting">
															{{ accrediting }}
														</li>
													</ul>
												</template>
												<v-spacer></v-spacer>
												<b>عدد ساعات الإعتماد:</b>
												{{ item.hoursCount }}
											</template>
											<template v-if="item.registrationLink">
												<v-spacer></v-spacer>
												<b>رابط التسجيل:</b>
												&nbsp;
												<a
													:href="item.registrationLink"
													target="_blank"
													rel="noopener noreferrer"
												>{{ item.registrationLink }}</a>
											</template>
										</v-col>
									</v-row>
								</td>
							</template>
						</v-data-table>
					</v-card-text>
				</v-tab-item>

				<v-tab-item value="tab-2">
					<v-card-text>
						<div class="text-subtitle-1 pb-2">
							<strong>التي تم انشاوها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="newsCreatedHeaders"
							:items="media.newsCreated == null ? [] : media.newsCreated"
							:loading="media.newsCreated == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'news-item', params: { recordID: item.id }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>

						<br>

						<div class="text-subtitle-1 pb-2">
							<strong>التي تم نشرها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="newsPublishedHeaders"
							:items="media.newsPublished == null ? [] : media.newsPublished"
							:loading="media.newsPublished == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'news-item', params: { recordID: item.id }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>
					</v-card-text>
				</v-tab-item>

				<v-tab-item value="tab-3">
					<v-card-text>
						<div class="text-subtitle-1 pb-2">
							<strong>التي تم انشاوها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="replacementsCreatedHeaders"
							:items="media.replacementsCreated == null ? [] : media.replacementsCreated"
							show-expand
							:loading="media.replacementsCreated == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'replacement', params: { recordID: item.replacementID }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>

						<br>

						<div class="text-subtitle-1 pb-2">
							<strong>التي تم نشرها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="replacementsPublishedHeaders"
							:items="media.replacementsPublished == null ? [] : media.replacementsPublished"
							show-expand
							:loading="media.replacementsPublished == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'replacement', params: { recordID: item.replacementID }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>
					</v-card-text>
				</v-tab-item>

				<v-tab-item value="tab-4">
					<v-card-text>
						<div class="text-subtitle-1 pb-2">
							<strong>التي تم انشاوها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="eventsCreatedHeaders"
							:items="media.eventsCreated == null ? [] : media.eventsCreated"
							:show-expand="false"
							:loading="media.eventsCreated == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'event', params: { recordID: item.eventID }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
							<template #expanded-item="{ item }">
								<td :colspan="eventsPublishedHeaders.length">
									<v-row>
										<v-col>
											<template v-if="item.registrationLink">
												<v-spacer></v-spacer>
												<b>رابط التسجيل:</b>
												&nbsp;
												<a
													:href="item.registrationLink"
													target="_blank"
													rel="noopener noreferrer"
												>{{ item.registrationLink }}</a>
											</template>
										</v-col>
									</v-row>
								</td>
							</template>
						</v-data-table>

						<br>

						<div class="text-subtitle-1 pb-2">
							<strong>التي تم نشرها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="eventsPublishedHeaders"
							:items="media.eventsPublished == null ? [] : media.eventsPublished"
							:show-expand="false"
							:loading="media.eventsPublished == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'event', params: { recordID: item.eventID }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
							<template #expanded-item="{ item }">
								<td :colspan="eventsPublishedHeaders.length">
									<v-row>
										<v-col>
											<template v-if="item.registrationLink">
												<v-spacer></v-spacer>
												<b>رابط التسجيل:</b>
												&nbsp;
												<a
													:href="item.registrationLink"
													target="_blank"
													rel="noopener noreferrer"
												>{{ item.registrationLink }}</a>
											</template>
										</v-col>
									</v-row>
								</td>
							</template>
						</v-data-table>
					</v-card-text>
				</v-tab-item>

				<v-tab-item value="tab-5">
					<v-card-text>
						<div class="text-subtitle-1 pb-2">
							<strong>التي تم انشاوها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="jobsCreatedHeaders"
							:items="media.jobsCreated == null ? [] : media.jobsCreated"
							:loading="media.jobsCreated == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'job', params: { jobID: item.jobID }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>

						<br>

						<div class="text-subtitle-1 pb-2">
							<strong>التي تم نشرها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="jobsPublishedHeaders"
							:items="media.jobsPublished == null ? [] : media.jobsPublished"
							:loading="media.jobsPublished == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'job', params: { jobID: item.jobID }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>
					</v-card-text>
				</v-tab-item>

				<v-tab-item value="tab-6">
					<v-card-text>
						<div class="text-subtitle-1 pb-2">
							<strong>التي تم انشاوها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="libraryCreatedHeaders"
							:items="media.libraryCreated == null ? [] : media.libraryCreated"
							:loading="media.libraryCreated == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'library-item', params: { recordID: item.id }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>

						<br>

						<div class="text-subtitle-1 pb-2">
							<strong>التي تم نشرها:</strong>
						</div>
						<v-data-table
							class="elevation-1"
							:headers="libraryPublishedHeaders"
							:items="media.libraryPublished == null ? [] : media.libraryPublished"
							:loading="media.libraryPublished == null"
						>
							<template #[`item.title`]="{ item }">
								<router-link :to="{ name: 'library-item', params: { recordID: item.id }}" target="_blank" class="primary--text">
									{{ item.title }}
								</router-link>
							</template>
						</v-data-table>
					</v-card-text>
				</v-tab-item>
			</v-tabs>
		</v-container>

		<v-dialog v-model="modifyEmailDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث البريد الإلكتروني</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid1">
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="newEmail"
									outlined
									hide-details="auto"
									label="البريد الإلكتروني"
									:rules="[rules.required, rules.email]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid1" :loading="loading" @click="updateEmail">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyPasswordDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث كلمة المرور</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid2">
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="currentPassword"
									outlined
									hide-details="auto"
									label="كلمة المرور الحالية"
									:rules="[rules.required, rules.password]"
								></v-text-field>
							</v-col>

							<v-col cols="12">
								<v-text-field
									v-model="newPassword"
									outlined
									hide-details="auto"
									label="كلمة المرور الجديدة"
									:rules="[rules.required, rules.password]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid2" :loading="loading" @click="updatePassword">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyPhoneDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث رقم الهاتف</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid3">
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="newPhone"
									outlined
									hide-details="auto"
									label="رقم الهاتف"
									placeholder="+966500000000"
									:rules="[rules.required, rules.mobile]"
								></v-text-field>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid3" :loading="loading" @click="updatePhone">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="modifyAvatarDialog" width="500">
			<v-card>
				<v-card-title primary-title>
					<v-spacer></v-spacer>
					<div>تحديث الصورة الشخصية</div>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text>
					<v-form v-model="valid4">
						<v-row>
							<v-col cols="12">
								<v-file-input
									v-model="newAvatar"
									outlined
									hide-details="auto"
									label="الصورة الجديدة"
									:rules="[rules.required]"
								></v-file-input>
							</v-col>

							<v-col cols="12" class="text-center pb-0">
								<v-btn color="primary" :disabled="!valid4" :loading="loading" @click="updateAvatar">تعديل</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";
import client from "@/client";
import clientNotifier from "@/clientNotifier";

export default {
	mixins: [rulesMixin, require("@/mixins/router-mixin").default],
	data() {
		return {
			tab: "tab-1",
			profile: {
				id: -1,
				displayName: "...",
				fullName: "...",
				email: "...",
				gender: "...",
				phoneNumber: "...",
				userGroup: "...",
				avatar: null,
				communications: [],
				specialties: null
			},
			notifications: {},
			notificationsMethods: {},
			tags: {
				cities: [],
				specialties: []
			},
			allCities: [],
			allSpecialties: [],
			newEmail: null,
			modifyEmailDialog: false,
			valid1: false,
			valid2: false,
			valid3: false,
			valid4: false,
			loading: false,
			newPhone: null,
			modifyPhoneDialog: false,
			newPassword: null,
			currentPassword: null,
			modifyPasswordDialog: false,
			newAvatar: null,
			modifyAvatarDialog: false,
			oldNoti: [],
			breadcrumbs: [
				{ text: 'لوحة التحكم', to: { name: "dashboard-home" } },
				{ text: 'المستخدمين', disabled: true, to: { name: 'dashboard-users' } },
				{ text: 'حساب مستخدم', disabled: true }
			],
			media: {
				coursesCreated: null,
				coursesPublished: null,
				newsCreated: null,
				newsPublished: null,
				replacementsCreated: null,
				replacementsPublished: null,
				eventsCreated: null,
				eventsPublished: null,
				jobsCreated: null,
				jobsPublished: null,
				libraryCreated: null,
				libraryPublished: null,
			},
			coursesCreatedHeaders: [
				{ text: "", value: "data-table-expand" },
				{
					text: "عنوان الدورة",
					value: "title"
				},
				// {
				// 	text: "الكاتب",
				// 	value: "userFullName"
				// },
				// {
				// 	text: "المجموعة",
				// 	value: "userGroup"
				// },
				{
					text: "الجهة المنظمة",
					value: "companyName"
				},
				{
					text: "حالة الدورة",
					value: "stateName"
				},
				{
					text: "تاريخ البداية",
					value: "startDate"
				},
				{
					text: "الناشر",
					value: "publisherFullName"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				},
			],
			coursesPublishedHeaders: [
				{ text: "", value: "data-table-expand" },
				{
					text: "عنوان الدورة",
					value: "title"
				},
				{
					text: "الكاتب",
					value: "userFullName"
				},
				{
					text: "المجموعة",
					value: "userGroup"
				},
				{
					text: "الجهة المنظمة",
					value: "companyName"
				},
				{
					text: "حالة الدورة",
					value: "stateName"
				},
				{
					text: "تاريخ البداية",
					value: "startDate"
				},
				// {
				// 	text: "الناشر",
				// 	value: "publisherFullName"
				// },
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				},
			],
			newsCreatedHeaders: [
				{
					text: "رقم الخبر",
					value: "id"
				},
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "الوصف",
					value: "description"
				},
				// {
				// 	text: "الكاتب",
				// 	value: "userName"
				// },
				{
					text: "الحالة",
					value: "stateName"
				},
				{
					text: "تاريخ النشر",
					value: "publishWri"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			newsPublishedHeaders: [
				{
					text: "رقم الخبر",
					value: "id"
				},
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "الوصف",
					value: "description"
				},
				{
					text: "الكاتب",
					value: "userName"
				},
				{
					text: "الحالة",
					value: "stateName"
				},
				{
					text: "تاريخ النشر",
					value: "publishWri"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			replacementsCreatedHeaders: [
				{
					text: "رقم الطلب",
					value: "replacementID"
				},
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "من منطقة",
					value: "fromRegion"
				},
				{
					text: "إلى منطقة",
					value: "toRegion"
				},
				{
					text: "الحالة",
					value: "state"
				},
				{
					text: "تاريخ النشر",
					value: "publishedWrite"
				},
				{
					text: "عدد العروض",
					value: "numberOfOffer"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			replacementsPublishedHeaders: [
				{
					text: "رقم الطلب",
					value: "replacementID"
				},
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "من منطقة",
					value: "fromRegion"
				},
				{
					text: "إلى منطقة",
					value: "toRegion"
				},
				{
					text: "الحالة",
					value: "state"
				},
				{
					text: "تاريخ النشر",
					value: "publishedWrite"
				},
				{
					text: "عدد العروض",
					value: "numberOfOffer"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			eventsCreatedHeaders: [
				// { text: "", value: "data-table-expand" },
				{
					text: "عنوان الفعالية",
					value: "title"
				},
				// {
				// 	text: "الكاتب",
				// 	value: "writer"
				// },
				{
					text: "حالة الفعالية",
					value: "state"
				},
				{
					text: "الناشر",
					value: "publisher"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			eventsPublishedHeaders: [
				// { text: "", value: "data-table-expand" },
				{
					text: "عنوان الفعالية",
					value: "title"
				},
				{
					text: "الكاتب",
					value: "writer"
				},
				{
					text: "حالة الفعالية",
					value: "state"
				},
				// {
				// 	text: "الناشر",
				// 	value: "publisher"
				// },
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			jobsCreatedHeaders: [
				{
					text: "عنوان الوظيفة",
					value: "title"
				},
				// {
				// 	text: "الكاتب",
				// 	value: "writerName"
				// },
				// {
				// 	text: "المجموعة",
				// 	value: "userGroup"
				// },
				{
					text: "الجهة المنظمة",
					value: "companyName"
				},
				{
					text: "حالة الوظيفة",
					value: "state"
				},
				// {
				// 	text: "تاريخ البداية",
				// 	value: "startDate"
				// },
				{
					text: "الناشر",
					value: "publisherName"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			jobsPublishedHeaders: [
				{
					text: "عنوان الوظيفة",
					value: "title"
				},
				{
					text: "الكاتب",
					value: "writerName"
				},
				// {
				// 	text: "المجموعة",
				// 	value: "userGroup"
				// },
				{
					text: "الجهة المنظمة",
					value: "companyName"
				},
				{
					text: "حالة الوظيفة",
					value: "state"
				},
				// {
				// 	text: "تاريخ البداية",
				// 	value: "startDate"
				// },
				// {
				// 	text: "الناشر",
				// 	value: "publisherName"
				// },
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				}
			],
			libraryCreatedHeaders: [
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "النوع",
					value: "type"
				},
				// {
				// 	text: "الكاتب",
				// 	value: "wrtier"
				// },
				{
					text: "الحالة",
					value: "state"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				},
			],
			libraryPublishedHeaders: [
				{
					text: "العنوان",
					value: "title"
				},
				{
					text: "النوع",
					value: "type"
				},
				{
					text: "الكاتب",
					value: "wrtier"
				},
				{
					text: "الحالة",
					value: "state"
				},
				{
					text: "عدد المشاهدات",
					value: "viewCount"
				},
			],
			headers: [
				{ value: "name", text: "موقع التواصل" },
				{ value: "value", text: "الرابط" },
				// { value: "actions", text: "عمليات", align: "end" }
			],
			communications: [],
			communicationLoading: true,
		};
	},
	computed: {
		isAdmin() {
			if(this.$store.state.profile)
				return this.$store.state.profile.userGroupID == "admins";
			else 
				return false;
		}
	},
	mounted() {
		this.getMyProfile();
		this.getSettings();
		this.getSpecialties();
		this.getCities();
		if(this.isAdmin){
			this.breadcrumbs[1].disabled = false;
		}
		this.getMedia();
	},
	methods: {
		getMedia () {
			this.getCoursesCreated();
			this.getCoursesPublished();
			this.getNewsCreated();
			this.getNewsPublished();
			this.getReplacementsCreated();
			this.getReplacementsPublished();
			this.getEventsCreated();
			this.getEventsPublished();
			this.getJobsCreated();
			this.getJobsPublished();
			this.getLibraryCreated();
			this.getLibraryPublished();
		},
		getCoursesCreated () {
			const id = this.$route.params.id;

			client
				.get("/api/users/course/created/" + id)
				.then(response => {
					console.log(response);
					this.media.coursesCreated = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCoursesPublished () {
			const id = this.$route.params.id;

			client
				.get("/api/users/course/published/" + id)
				.then(response => {
					console.log(response);
					this.media.coursesPublished = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getNewsCreated () {
			const id = this.$route.params.id;

			client
				.get("/api/users/news/created/" + id)
				.then(response => {
					console.log(response);
					this.media.newsCreated = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getNewsPublished () {
			const id = this.$route.params.id;

			client
				.get("/api/users/news/published/" + id)
				.then(response => {
					console.log(response);
					this.media.newsPublished = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getReplacementsCreated () {
			const id = this.$route.params.id;

			client
				.get("/api/users/replacements/created/" + id)
				.then(response => {
					console.log(response);
					this.media.replacementsCreated = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getReplacementsPublished () {
			const id = this.$route.params.id;

			client
				.get("/api/users/replacements/published/" + id)
				.then(response => {
					console.log(response);
					this.media.replacementsPublished = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getEventsCreated () {
			const id = this.$route.params.id;

			client
				.get("/api/users/event/created/" + id)
				.then(response => {
					console.log(response);
					this.media.eventsCreated = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getEventsPublished () {
			const id = this.$route.params.id;

			client
				.get("/api/users/event/published/" + id)
				.then(response => {
					console.log(response);
					this.media.eventsPublished = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getJobsCreated () {
			const id = this.$route.params.id;

			client
				.get("/api/users/job/created/" + id)
				.then(response => {
					console.log(response);
					this.media.jobsCreated = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getJobsPublished () {
			const id = this.$route.params.id;

			client
				.get("/api/users/job/published/" + id)
				.then(response => {
					console.log(response);
					this.media.jobsPublished = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getLibraryCreated () {
			const id = this.$route.params.id;

			client
				.get("/api/users/library/created/" + id)
				.then(response => {
					console.log(response);
					this.media.libraryCreated = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getLibraryPublished () {
			const id = this.$route.params.id;

			client
				.get("/api/users/library/published/" + id)
				.then(response => {
					console.log(response);
					this.media.libraryPublished = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});
		},
		getMyProfile() {
			const id = this.$route.params.id;

			client
				.get("/api/users/show/" + id)
				.then(response => {
					console.log(response);
					this.profile = response.data.data;
					
					if (this.profile.gender == "M") {
						this.profile.gender = "ذكر"
					} else if (this.profile.gender == "F") {
						this.profile.gender = "انثى"
					}

					this.breadcrumbs[2].text = this.profile.fullName

					if (this.profile.avatar == null || this.profile.avatar == "" || this.profile.avatar == "https://ertiqa.svod.app/storage") {
						if (this.profile.gender == "F") {
							this.profile.avatar = "https://www.w3schools.com/w3images/avatar4.png"
						} else {
							this.profile.avatar = "https://www.w3schools.com/w3images/avatar2.png"
						}
					}

					this.getCommunications();
				})
				.catch(err => {
					console.log(err);
				});
		},
		removeCity(index) {
			console.log(index);
		},
		showModifyEmailDialog() {
			this.modifyEmailDialog = true;
		},
		showModifyPasswordDialog() {
			this.modifyPasswordDialog = true;
		},
		showModifyPhoneDialog() {
			this.modifyPhoneDialog = true;
		},
		showModifyAvatarDialog() {
			this.modifyAvatarDialog = true;
		},
		updateEmail() {
			this.loading = true;
			client
				.post("/api/myprofile/changemyemail", { email: this.newEmail })
				.then(response => {
					console.log(response);
					this.modifyEmailDialog = false;
					this.profile.email = "" + this.newEmail;
					this.$store.dispatch("notify", {
						message: "تم تحديث البريد الإلكتروني",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث البريد الإلكتروني",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updatePhone() {
			this.loading = true;
			client
				.post("/api/myprofile/changemyphonenumber", {
					phoneNumber: this.newPhone
				})
				.then(response => {
					console.log(response);
					this.modifyPhoneDialog = false;
					this.profile.phoneNumber = "" + this.newPhone;
					this.$store.dispatch("notify", {
						message: "تم تحديث رقم لهاتف",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث رقم لهاتف",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updatePassword() {
			this.loading = true;
			var data = {
				currentPassword: this.currentPassword,
				newPassword: this.newPassword,
				newPassword_Confirmation: this.newPassword
			};

			client
				.post("/api/myprofile/changemyPassword", data)
				.then(response => {
					console.log(response);
					this.modifyPasswordDialog = false;
					this.$store.dispatch("notify", {
						message: "تم تحديث كلمة المرور",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث كلمة المرور",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		updateAvatar() {
			this.loading = true;

			var data = new FormData();
			data.append("name", "avatar");
			data.append("description", "avatar");
			data.append("attachment", this.newAvatar);

			client
				.post("/api/myprofile/changemyavatar", data)
				.then(response => {
					console.log(response);
					this.modifyAvatarDialog = false;
					this.profile.avatar = "" + this.newAvatar;
					this.$store.dispatch("notify", {
						message: "تم تحديث الصورة الشخصية",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث الصورة الشخصية",
						color: "error"
					});
				})
				.finally(() => {
					this.loading = false;
				});
		},
		saveNotifications() {
			this.loading = true;

			client
				.post(
					"/api/myprofile/changenotfimethod",
					this.notificationsMethods
				)
				.then(response => {
					console.log(response);
					this.$store.dispatch("notify", {
						message: "تم تحديث",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث",
						color: "error"
					});
				});

			var addData = {
				cities: [],
				specialities: [],
				sections: []
			};

			var removeData = {
				cities: [],
				specialities: [],
				sections: []
			};

			var sections = ["courses", "news", "events", "jobs", "switch"];
			sections.forEach(section => {
				if (this.notifications[section]) {
					if (this.oldNoti.sections.indexOf(section) == -1) {
						addData.sections.push(section);
					}
				} else {
					if (this.oldNoti.sections.indexOf(section) != -1) {
						removeData.sections.push(section);
					}
				}
			});

			this.allCities.forEach(city => {
				var cityID = city.cityID;
				var selected = this.tags.cities;
				if (selected.indexOf(cityID) != -1) {
					if (this.oldNoti.cities.indexOf(cityID) == -1) {
						addData.cities.push(cityID);
					}
				} else {
					if (this.oldNoti.cities.indexOf(cityID) != -1) {
						removeData.cities.push(cityID);
					}
				}
			});

			this.allSpecialties.forEach(speciality => {
				var specID = speciality.specialtiesID;
				var selected = this.tags.specialties;
				if (selected.indexOf(specID) != -1) {
					if (this.oldNoti.specialities.indexOf(specID) == -1) {
						addData.specialities.push(specID);
					}
				} else {
					if (this.oldNoti.specialities.indexOf(specID) != -1) {
						removeData.specialities.push(specID);
					}
				}
			});

			removeData.sections.forEach(notif => {
				client
					.post("/api/myprofile/unsetnotfifavorite", {
						favoriteID: notif
					})
					.then(response => {
						console.log(response);
						var index = this.oldNoti.sections.indexOf(notif);
						this.oldNoti.sections.splice(index, 1);
					})
					.catch(err => {
						console.log(err);
					});
			});

			removeData.cities.forEach(notif => {
				client
					.post("/api/myprofile/unsetnotfifavorite", {
						favoriteID: notif
					})
					.then(response => {
						console.log(response);
						var index = this.oldNoti.cities.indexOf(notif);
						this.oldNoti.cities.splice(index, 1);
					})
					.catch(err => {
						console.log(err);
					});
			});

			removeData.specialities.forEach(notif => {
				client
					.post("/api/myprofile/unsetnotfifavorite", {
						favoriteID: notif
					})
					.then(response => {
						console.log(response);
						var index = this.oldNoti.specialities.indexOf(notif);
						this.oldNoti.specialities.splice(index, 1);
					})
					.catch(err => {
						console.log(err);
					});
			});

			client
				.post("/api/myprofile/setnotfifavorites", addData)
				.then(response => {
					console.log(response);
					addData.sections.forEach(item => {
						this.oldNoti.sections.push(item);
					});
					addData.cities.forEach(item => {
						this.oldNoti.cities.push(item);
					});
					addData.specialities.forEach(item => {
						this.oldNoti.specialities.push(item);
					});
					this.$store.dispatch("notify", {
						message: "تم تحديث",
						color: "primary"
					});
				})
				.catch(err => {
					console.log(err);
					this.$store.dispatch("notify", {
						message: "فشلت عملية تحديث",
						color: "error"
					});
				});
		},
		getSettings() {
			client
				.get("/api/myprofile/getnotfimethod")
				.then(response => {
					console.log(response);
					this.notificationsMethods = response.data.data;
				})
				.catch(err => {
					console.log(err);
				});

			client
				.get("/api/myprofile/getnotfifavorite")
				.then(response => {
					console.log(response);
					var noti = response.data.data;
					this.oldNoti = noti;

					if (!noti.sections) {
						noti.sections = [];
					}

					this.notifications = {
						courses: noti.sections.indexOf("courses") != -1,
						news: noti.sections.indexOf("news") != -1,
						events: noti.sections.indexOf("events") != -1,
						jobs: noti.sections.indexOf("jobs") != -1,
						switch: noti.sections.indexOf("switch") != -1
					};

					if (noti.cities && noti.cities.length) {
						this.tags.cities = [...noti.cities];
					} else {
						noti.cities = [];
						this.tags.cities = [];
					}
					if (noti.specialities && noti.specialities.length) {
						this.tags.specialties = [...noti.specialities];
					} else {
						noti.specialities = [];
						this.tags.specialties = [];
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		getSpecialties() {
			client
				.get("/api/specialties/all")
				.then(response => {
					this.allSpecialties = response.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCities() {
			client
				.get("/api/location/cities")
				.then(response => {
					this.allCities = response.data.data;
					console.log(response);
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCommunications() {
			client
				.get("/api/communication/types")
				.then(response => {
					this.communications = response.data
						.filter(communication => {
							const allowed = ['facebook', 'linkedin', 'telegram', 'twitter', 'whatsapp'];
							return allowed.indexOf(communication.communicationTypeID) != -1;
						})
						.map(communication => {
							const thisCom = this.profile.communications.find(com => com.name == communication.name);
							communication.isEdit = false;
							communication.valid = false;
							if (thisCom) {
								communication.exist = true;
								communication.id = thisCom.id;
								communication.value = thisCom.value;
							} else {
								communication.exist = false;
								communication.id = null;
							}
							return communication
						});
					this.loading = false;
					this.communicationLoading = false;
				})
		},
		enableEditCommunication(item) {
			if(item.isEdit) {
				this.updateInfo(item)
			} else {
				item.value = item.initialProfilesPath
				item.isEdit = true;
			}
		},
		updateInfo(item){
			item.isLoading = true;

			clientNotifier
				.post("/api/myprofile/newCommunication", item)
				.then(response => {
					item.isEdit = false;
					item.exist = true;
					item.id = response.data.data.id;
					item.value = response.data.data.value;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
		removeCommunication(item){
			item.isLoading = true;

			clientNotifier
				.delete("/api/myprofile/deletecommunication/" + item.id)
				.then(response => {
					if (response == undefined) throw new Error("delete does not use then/catch");
					item.isEdit = false;
					item.exist = false;
					item.id = null;
					item.value = null;
				})
				.finally(() => {
					item.isLoading = false;
				});
		},
		updateSpeciality() {
			this.loading = true;
			const data = {
				specialtiesID: this.profile.specialties
			}
			clientNotifier
				.post("/api/myprofile/changeMySpecialties", data)
				.then(response => {
					console.log(response)
				})
				.finally(() => {
					this.loading = false;
				});
		}
	}
};
</script>

<style scoped>
span {
	vertical-align: center;
}
</style>